import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { Toolbar } from 'primereact/toolbar';
import { ProvisionalListColumns } from '../../../appconfig/DatatableSetting';
import { formatDate } from '../../../appconfig/AppHelper';
import { applicationsDOBTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { PROVISIONAL_CERTIFICATE_LIST } from '../../../config/ApiConstant';
import { getAllDetails } from '../../../service/ProductService';
import moment from 'moment';

export const ProvisionalCertificateList = () => {
    document.title = 'Provisional Certificate List | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    // Date Object
    let today = new Date();
    const [dates, setDates] = useState<string | Date | Date[] | any | null>([new Date(today.setDate(today.getDate() - 31)), new Date()]);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [certificateList, setCertificateList] = useState<any>([]);

    // useEffect
    useEffect(() => {
        getCertificateList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    },[dates]);

    // Get certificate list
    const getCertificateList = async () => {
        try{
            setPageLoad(false);
            let startDate = moment(dates[0]).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates[1]).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetails(PROVISIONAL_CERTIFICATE_LIST + '?start_date=' + startDate + '&end_date=' + endDate);
            if (response) {
                setPageLoad(true);
                setCertificateList(response);
            }
        }catch (error: any) {
            setPageLoad(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // On Date Change
    const onDateChange = (e: any) => {
        setDates(e.value);
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Calendar
                    value={dates}
                    dateFormat="dd/mm/yy"
                    onChange={(e) => onDateChange(e)}
                    selectionMode="range"
                    showIcon
                    className='ml-2'
                />
                <Button
                    icon="pi pi-filter-slash"
                    label="Clear"
                    onClick={() => clearAll()}
                    className="p-button-outlined ml-2">
                </Button>
            </>
        );
    };

    // Template for provisional issue date
    const ProIDateTemplate = (rowData: any) => {
        return(
            <>
                {!window.cn(rowData.ProIDate) ? formatDate(rowData.ProIDate) : ""}
            </>
        )
    };

    // Template for PAddress
    const PAddressTemplate = (rowData: any) => {
        return(
            <>
                <Button tooltip={rowData?.PAddress} className='p-button-custom-tooltip' tooltipOptions={{position: "top"}} >
                    <div className="college-name-div">
                        {!window.cn(rowData.PAddress) ? rowData.PAddress : ""}
                    </div>
                </Button>
            </>
        )
    };

    return(
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Certificate'} pageName={'Provisional Certificate List'} pageTitle={'Provisional Certificate List'} goToPage={true}/>
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={certificateList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={certificateList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Certificates Found"
                                    removableSort
                                >
                                    {ProvisionalListColumns.map((col, i) => {
                                        if(col.field === "BOD"){
                                            return <Column key={col.field} field={col.field} header={col.header} body={applicationsDOBTemplate} style={{minWidth : "8rem"}}/>;
                                        } else if(col.field === "ProIDate"){
                                            return <Column key={col.field} field={col.field} header={col.header} body={ProIDateTemplate} style={{minWidth : "8rem"}} />;
                                        } else if(col.field === "PAddress"){
                                            return <Column key={col.field} field={col.field} header={col.header} body={PAddressTemplate} />;
                                        }else if(col.field === "SrNo"){
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} style={{minWidth:'9rem'}} />;
                                        } else if(col.field === "RegNo"){
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} style={{minWidth:'9rem'}} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ProvisionalListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
};